// Resolves a stored media path to a loadable URL.
// Backend now stores relative paths like "/uploads/products/images/x.webp";
// prepend the backend origin so the browser can fetch them. Absolute URLs,
// data: URIs and blob: URLs (local previews) are returned unchanged.
export default function mediaUrl(path) {
  if (!path) return path;
  if (/^(https?:)?\/\//i.test(path) || path.startsWith('data:') || path.startsWith('blob:')) {
    return path;
  }
  const base = process.env.REACT_APP_BACKEND_URL || '';
  return `${base}${path.startsWith('/') ? '' : '/'}${path}`;
}
